// our-stores links: previous fix attempts deadlocked with target="_blank" in
// the menu template (capture-phase handler called stopImmediatePropagation +
// window.location.assign without preventDefault, racing the new-tab default
// action). target="_blank" has now been removed from the template and
// data-no-instant is rendered there directly, so no JS is needed here.


// Custom product image opener — replaces fancybox lightbox
document.addEventListener("DOMContentLoaded", function () {

  if (!document.querySelector('.product_section')) return;

  function isMobile() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }

function getCappedImageUrl(target) {
    var src = target.currentSrc || target.src;
    src = src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(\.|_)/, '.');
    src = src.split('?')[0];
    var separator = src.indexOf('?') === -1 ? '?' : '&';
    
    if (isMobile()) {
      return src + separator + 'width=1500&quality=80';
    }
    return src + separator + 'width=2400';
  }
  // ===== MOBILE: PhotoSwipe overlay (self-hosted) =====
  // Was: navigate the whole page to the bare capped JPG. That meant a white
  // screen while an uncached 1500px image downloaded on cellular, and Back
  // to return. PhotoSwipe opens instantly instead: msrc shows the gallery
  // image ALREADY on screen while the high-res loads behind it, with the
  // pinch/double-tap/swipe/drag-down gestures shoppers expect.
  if (isMobile()) {
    var gallery = document.querySelector('.product_gallery');
    if (gallery) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchStartTime = 0;
      var touchMoved = false;
      var lastTouchEnd = 0;

      // Module + CSS are lazy: fetched on the FIRST touch anywhere in the
      // gallery (~60KB total, cached after that), so they cost the initial
      // page load nothing and are warm by the time a tap lands.
      // new Function keeps import() out of the parse path — on a pre-2018
      // browser that lacks dynamic import, only the loader breaks (we fall
      // back to the old navigation), not this whole file.
      var pswpModulePromise = null;
      var ownScript = document.querySelector('script[src*="assets/custom.js"]');
      var assetBase = ownScript ? ownScript.src.replace(/custom\.js[^/]*$/, '') : '';
      var dynImport;
      try { dynImport = new Function('u', 'return import(u)'); } catch (err) { dynImport = null; }

      function loadPswp() {
        if (!assetBase || !dynImport) return null;
        if (!pswpModulePromise) {
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = assetBase + 'photoswipe.css';
          document.head.appendChild(link);
          pswpModulePromise = dynImport(assetBase + 'photoswipe.esm.min.js')
            .catch(function() { return null; });
        }
        return pswpModulePromise;
      }

      function buildSlides() {
        var imgs = Array.prototype.slice.call(
          gallery.querySelectorAll('.gallery-cell .image__container img'));
        return imgs.map(function(img) {
          // PhotoSwipe needs the intrinsic w/h of the src we hand it, or it
          // stretches the photo to whatever box we declare. data-aspectratio
          // is USELESS here at runtime — the lazysizes aspectratio plugin in
          // theme.liquid consumes and REMOVES that attribute on load (square
          // products masked this; landscape Bali photos got squashed into
          // 1:1). The loaded gallery image's natural dims carry the true
          // ratio instead — every Shopify CDN size variant, even the 100x
          // placeholder, preserves it. loadComplete below snaps to the exact
          // served dims once the full image arrives.
          var ratio = 1;
          if (img.naturalWidth > 0 && img.naturalHeight > 0) {
            ratio = img.naturalHeight / img.naturalWidth;
          }
          // Placeholder: the already-on-screen image, UNLESS it's still the
          // 100x lazyload stub (slides deep in a long gallery) — full-screen
          // 100px mush reads as broken. The 800w srcset variant shows ~4x
          // sooner than the 1500px main image on cellular.
          var msrc = img.currentSrc || img.src;
          if (/_100x\./.test(msrc)) {
            var m = (img.getAttribute('srcset') || img.getAttribute('data-srcset') || '')
              .match(/(\S+)\s+800w/);
            if (m) msrc = m[1];
          }
          return {
            src: getCappedImageUrl(img),
            msrc: msrc,
            width: 1500,
            height: Math.round(1500 * ratio),
            paImg: img
          };
        });
      }

      function openPswp(target) {
        var loader = loadPswp();
        if (!loader) { window.location.href = getCappedImageUrl(target); return; }
        loader.then(function(mod) {
          if (!mod || !mod.default) { window.location.href = getCappedImageUrl(target); return; }
          var slides = buildSlides();
          var index = 0;
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].paImg === target) { index = i; break; }
          }
          var pswp = new mod.default({
            dataSource: slides,
            index: index,
            pinchToClose: true,
            showHideAnimationType: 'fade',
            bgOpacity: 0.95
          });
          // Back button closes the viewer instead of leaving the PDP.
          var pushed = false;
          var popped = false;
          var onPop = function() { popped = true; pswp.close(); };
          pswp.on('afterInit', function() {
            history.pushState({ paPswp: 1 }, '');
            pushed = true;
            window.addEventListener('popstate', onPop);
          });
          pswp.on('destroy', function() {
            window.removeEventListener('popstate', onPop);
            if (pushed && !popped) history.back();
          });
          // Snap each slide to the dims the CDN actually served (the
          // declared 1500-wide guess is wrong for sub-1500px sources, and
          // the ratio guess can drift a pixel from 100x rounding).
          pswp.on('loadComplete', function(e) {
            var c = e.content;
            var el = c && c.element;
            if (!el || !el.naturalWidth || !c.data) return;
            if (c.data.width !== el.naturalWidth || c.data.height !== el.naturalHeight) {
              c.data.width = el.naturalWidth;
              c.data.height = el.naturalHeight;
              pswp.refreshSlideContent(c.index);
            }
          });
          pswp.init();
        });
      }

      gallery.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartTime = Date.now();
        touchMoved = false;
        loadPswp();
      }, { passive: true });

      gallery.addEventListener('touchmove', function(e) {
        var dx = Math.abs(e.touches[0].clientX - touchStartX);
        var dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx > 5 || dy > 5) touchMoved = true;
      }, { passive: true });

      gallery.addEventListener('touchend', function(e) {
        lastTouchEnd = Date.now();
        var target = e.target;
        if (target.tagName !== 'IMG') return;
        if (target.closest('.product_gallery_nav')) return;

        if (touchMoved) return;

        var duration = Date.now() - touchStartTime;
        if (duration > 300) return;

        var flkty = Flickity && Flickity.data(gallery);
        if (flkty && flkty.isAnimating) return;

        e.preventDefault();
        e.stopPropagation();

        openPswp(target);
      });

      gallery.addEventListener('click', function(e) {
        // Ghost clicks: iOS fires a click right after touchend. Every
        // deliberate tap has already navigated (and preventDefault'ed the
        // click) in the touchend handler above — so a click arriving on the
        // heels of a touch means touchend REJECTED that tap (mid-swipe,
        // mid-settle, long-press). Navigating here anyway was how a tap
        // during the settle animation yanked the page to the bare JPG with
        // the slide frozen halfway across the screen.
        if (Date.now() - lastTouchEnd < 700) return;

        var target = e.target;
        if (target.tagName !== 'IMG') return;
        if (target.closest('.product_gallery_nav')) return;

        if (touchMoved) {
          touchMoved = false;
          return;
        }

        var flkty = Flickity && Flickity.data(gallery);
        if (flkty && (flkty.isAnimating || flkty.isDragging)) return;

        e.preventDefault();
        e.stopPropagation();
        openPswp(target);
      });
    }
    return;
  }

  // ===== DESKTOP: custom lightbox overlay =====
  var overlay = document.createElement('div');
  overlay.id = 'pa-lightbox';
  overlay.style.cssText = 'display:none;position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.9);z-index:99999;align-items:center;justify-content:center;cursor:zoom-out;';
  overlay.innerHTML = '<button id="pa-lightbox-close" style="position:absolute;top:20px;right:30px;background:transparent;border:none;color:#fff;font-size:40px;line-height:1;cursor:pointer;font-family:Arial,sans-serif;padding:0;width:40px;height:40px;z-index:2;">&times;</button><button id="pa-lightbox-prev" style="position:absolute;left:30px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.1);border:none;color:#fff;font-size:32px;line-height:1;cursor:pointer;font-family:Arial,sans-serif;padding:0;width:50px;height:50px;border-radius:50%;z-index:2;">&#8249;</button><button id="pa-lightbox-next" style="position:absolute;right:30px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.1);border:none;color:#fff;font-size:32px;line-height:1;cursor:pointer;font-family:Arial,sans-serif;padding:0;width:50px;height:50px;border-radius:50%;z-index:2;">&#8250;</button><img id="pa-lightbox-img" style="max-width:90vw;max-height:90vh;object-fit:contain;cursor:default;" alt="">';
  document.body.appendChild(overlay);

  var overlayImg = document.getElementById('pa-lightbox-img');
  var closeBtn = document.getElementById('pa-lightbox-close');
  var prevBtn = document.getElementById('pa-lightbox-prev');
  var nextBtn = document.getElementById('pa-lightbox-next');
  // Hover-zoom: scale image and pan based on cursor position
  overlayImg.addEventListener('mousemove', function(e) {
    var rect = overlayImg.getBoundingClientRect();
    var xPercent = ((e.clientX - rect.left) / rect.width) * 100;
    var yPercent = ((e.clientY - rect.top) / rect.height) * 100;
    overlayImg.style.transformOrigin = xPercent + '% ' + yPercent + '%';
    overlayImg.style.transform = 'scale(2.5)';
    overlayImg.style.cursor = 'zoom-out';
    overlayImg.style.transition = 'transform 0.1s ease-out';
  });
  
  overlayImg.addEventListener('mouseleave', function() {
    overlayImg.style.transform = 'scale(1)';
    overlayImg.style.cursor = 'default';
  });

  var galleryImages = [];
  var currentIndex = 0;

  function openLightbox(highRes, lowRes, index) {
    overlayImg.src = lowRes || highRes;
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    currentIndex = index || 0;

    if (lowRes && lowRes !== highRes) {
      var preloader = new Image();
      preloader.onload = function() {
        overlayImg.src = highRes;
      };
      preloader.src = highRes;
    }
  }

var navigating = false;
  
  function navigateLightbox(direction) {
    if (galleryImages.length === 0) return;
    if (navigating) return;
    navigating = true;
    setTimeout(function() { navigating = false; }, 250);
    
    currentIndex = (currentIndex + direction + galleryImages.length) % galleryImages.length;
    var img = galleryImages[currentIndex];
    var lowRes = img.currentSrc || img.src;
    var highRes = getCappedImageUrl(img);

    overlayImg.src = lowRes;
    if (lowRes !== highRes) {
      var preloader = new Image();
      preloader.onload = function() {
        overlayImg.src = highRes;
      };
      preloader.src = highRes;
    }
  }

  function closeLightbox() {
    overlay.style.display = 'none';
    overlayImg.src = '';
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', function(e) {
    if (e.target === overlayImg) return;
    if (e.target === prevBtn || e.target === nextBtn) return;
    closeLightbox();
  });

  closeBtn.addEventListener('click', closeLightbox);

var lastNavTime = 0;
  
  prevBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    var now = Date.now();
    if (now - lastNavTime < 200) return;
    lastNavTime = now;
    navigateLightbox(-1);
  });

  nextBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    var now = Date.now();
    if (now - lastNavTime < 200) return;
    lastNavTime = now;
    navigateLightbox(1);
  });

  document.addEventListener('keydown', function(e) {
    if (overlay.style.display !== 'flex') return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') navigateLightbox(-1);
    if (e.key === 'ArrowRight') navigateLightbox(1);
  });

  galleryImages = Array.prototype.slice.call(document.querySelectorAll('.product_gallery img')).filter(function(img) {
    return !img.closest('.product_gallery_nav');
  });

  galleryImages.forEach(function(img, index) {
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var lowRes = this.currentSrc || this.src;
      openLightbox(getCappedImageUrl(this), lowRes, index);
    });
  });

});


// Resume slideshow after user interaction
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var slider = document.querySelector('.slideshow-wrapper');
    if (!slider) return;
    var flkty = Flickity.data(slider);
    if (!flkty) return;
    slider.addEventListener('pointerup', function() {
      setTimeout(function() { flkty.playPlayer(); }, 3000);
    });
    slider.addEventListener('touchend', function() {
      setTimeout(function() { flkty.playPlayer(); }, 3000);
    });
  }, 1000);
});

// Speed up Safari iOS back-navigation by handling bfcache restore
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    document.documentElement.classList.add('bfcache-restored');
    setTimeout(function() {
      window.scrollBy(0, 0);
    }, 0);
  }
});

// Normalize current_price after variant changes (product page only).
// The theme's variant handler rewrites this span via Shopify.formatMoney, which
// always emits a plain "$3,496.00" — so re-apply the PDP treatment every time:
// strip the thousands comma, raise a small currency mark, and raise REAL cents as
// small sup digits (.pa-cents, no decimal point — sign-style; whole dollars show
// no cents at all). Must stay in sync with the Liquid render in
// product-details-template + product-info. The .pa-cur guard stops the
// MutationObserver from re-entering.
document.addEventListener('DOMContentLoaded', function() {
  // BOTH price homes, not just the main one: the theme's currency JS rewrites
  // every .money span on load with a plain formatted string, which wipes the
  // Liquid-rendered sup markup out of the sticky bar too (verified 2026-08-06 —
  // sticky showed "$2,499.90" while main showed the raised form). Each element
  // gets the same normalize + observer so a wipe from any source self-heals.
  var priceEls = [
    document.querySelector('.product_section .current_price'),
    document.querySelector('#paStickyPrice .current_price')
  ].filter(Boolean);
  if (!priceEls.length) return;
  var priceEl = priceEls[0]; // main price — flashPrice below animates only this one

  function normalizePrice() {
    var moneySpans = [];
    priceEls.forEach(function(el) {
      moneySpans = moneySpans.concat(Array.prototype.slice.call(el.querySelectorAll('.money')));
    });
    moneySpans.forEach(function(span) {
      if (span.querySelector('.pa-cur')) return;
      // Trim BEFORE matching — formatMoney's output can carry trailing
      // whitespace, which defeats the anchored regex.
      var txt = span.textContent.replace(/\s+/g, ' ').trim().replace(/,/g, '');
      var m = txt.match(/^\$(\d+)(?:\.(\d{2}))?$/);
      if (m) {
        // "$3496.00" or bare "$3496" → raised $; cents raised ONLY when non-zero,
        // so a whole-dollar price renders "$3496" with nothing trailing.
        // aria-hidden visual + .pa-sr real price, same structure as the Liquid
        // render: the raised cents drop the decimal point, so bare textContent
        // would read $249990 to a screen reader. The .pa-sr copy always keeps the
        // full "$3496.00" — the ".00" is dead weight visually, not aurally.
        var cents = m[2] || '00';
        span.innerHTML = '<span aria-hidden="true"><sup class="pa-cur">$</sup>' + m[1] +
          (cents === '00' ? '' : '<sup class="pa-cents">' + cents + '</sup>') + '</span>' +
          '<span class="pa-sr">$' + m[1] + '.' + cents + '</span>';
      } else if (txt.charAt(0) === '$') {
        // Unexpected shape (currency suffix, fractional oddity): keep the raised $
        // but leave the rest verbatim rather than guessing at cents.
        span.innerHTML = '<sup class="pa-cur">$</sup>' + txt.slice(1);
      } else if (txt !== span.textContent) {
        span.textContent = txt;
      }
    });
  }

normalizePrice();
  
  function flashPrice() {
    priceEl.style.animation = 'none';
    void priceEl.offsetWidth;
    priceEl.style.animation = 'priceFlash 0.6s ease';
  }
  
  var observer = new MutationObserver(function() {
    normalizePrice();
    flashPrice();
  });
  priceEls.forEach(function(el) {
    observer.observe(el, { childList: true, subtree: true, characterData: true });
  });
});

// Mobile header offset shim (added 2026-05-27).
// -----------------------------------------------------------------------------
// `#header.mobile_nav-fixed--true` is position:fixed/top:0/z-index:1001. The
// theme's mobile CSS only pads `#pagecontent` with `padding-bottom: 40px`
// ($topMenuHeight), which (a) is on the wrong side to push content past the
// header and (b) hard-codes a value that no longer matches reality. After the
// 2026-05-27 nav modernization the rendered header is ~112px on mobile
// (promo_banner ~56 + top_bar ~56) — so the top ~80px of any first-on-page
// element (PDP gallery image, collection title, etc.) sits behind the fixed
// header and gets visually cropped.
//
// Fix: measure the actual fixed header height and apply it as body padding-top
// on mobile. Re-measures on resize, on promo-banner dismissal, and after any
// header DOM mutation (e.g. cart count change re-rendering the bag icon).
// Only runs when #header is actually position:fixed — so desktop and the
// transparent-header layouts are untouched.
(function () {
  function applyHeaderOffset() {
    var header = document.getElementById('header');
    var body = document.body;
    if (!header || !body) return;
    var isFixed = window.getComputedStyle(header).position === 'fixed';
    if (!isFixed) {
      body.style.paddingTop = '';
      return;
    }
    // Zero out the legacy `.page-banner { margin-top }` rule before
    // measuring — otherwise pages that have a page-banner would double-offset.
    body.style.paddingTop = header.offsetHeight + 'px';
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHeaderOffset);
  } else {
    applyHeaderOffset();
  }
  window.addEventListener('load', applyHeaderOffset);
  window.addEventListener('resize', applyHeaderOffset, { passive: true });
  // Re-measure if the header re-renders (promo banner close, cart update, etc).
  if (typeof MutationObserver !== 'undefined') {
    var headerEl = document.getElementById('header');
    if (headerEl) {
      new MutationObserver(applyHeaderOffset).observe(headerEl, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
  }
})();

// Sticky price bar — show when main price is scrolled out of view.
// Stacks under the sticky_nav (header clone) when that's visible so the user
// keeps both the nav and the price/CTA in view.
document.addEventListener('DOMContentLoaded', function() {
  var stickyBar = document.getElementById('paStickyPrice');
  var mainPrice = document.querySelector('.product_section .modal_price');
  if (!stickyBar || !mainPrice) return;

  stickyBar.style.display = 'block';

  function positionUnderStickyNav() {
    // Mobile (<=768): the bar is pinned to the BOTTOM via CSS — never set an
    // inline top, which would override the bottom positioning.
    if (window.innerWidth <= 768) { stickyBar.style.top = ''; return; }
    // Desktop: stack under the Headhesive sticky_nav clone when it's visible.
    var stickyNav = document.querySelector('.main_nav_wrapper.sticky_nav.sticky_nav--stick');
    if (stickyNav && stickyNav.offsetHeight > 0) {
      stickyBar.style.top = stickyNav.offsetHeight + 'px';
      return;
    }
    // Mobile: #header is position:fixed at top:0 (mobile_nav-fixed--true), so
    // stack under that instead. offsetHeight on a hidden element is 0, so this
    // also handles desktop-without-sticky_nav (returns 0 as expected).
    var mobileHeader = document.getElementById('header');
    if (mobileHeader && mobileHeader.offsetHeight > 0 && window.getComputedStyle(mobileHeader).position === 'fixed') {
      stickyBar.style.top = mobileHeader.offsetHeight + 'px';
      return;
    }
    stickyBar.style.top = '0px';
  }

  function checkScroll() {
    var rect = mainPrice.getBoundingClientRect();
    if (rect.bottom < 0) {
      stickyBar.classList.add('is-visible');
      positionUnderStickyNav();
    } else {
      stickyBar.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  window.addEventListener('resize', positionUnderStickyNav, { passive: true });
  checkScroll();

  // Single-variant PDPs render <button data-pa-sticky-add> instead of the
  // scroll anchor. Forward the click to the real Add to Cart button so we
  // inherit whatever the theme already does (ajax drawer, redirect, etc.) —
  // no duplicated cart logic to drift.
  var stickyAddBtn = stickyBar.querySelector('[data-pa-sticky-add]');
  if (stickyAddBtn) {
    stickyAddBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var realBtn = document.querySelector('.product_form button[name="add"]');
      if (realBtn) realBtn.click();
    });
  }
});